import React from 'react';
import cn from 'classnames';

import classes from './IconAvatar.module.scss';
import Icons, { getIconByType } from '../Icons';

export default function IconAvatar(
  props: {
    categoryIcon?: string;
    iconClass?: string;
    wrapperClass?: string;
  } = {}
) {
  const { categoryIcon = '', iconClass = '', wrapperClass = '' } = props;
  const selectedIconType = getIconByType(categoryIcon);

  return (
    <div className={cn(classes.IconAvatar, 'IconAvatar', classes[selectedIconType], wrapperClass)}>
      <Icons iconType={selectedIconType} iconClass={iconClass ? iconClass : classes.iconClass} />
    </div>
  );
}
